/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-18 09:55:30
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import CheckLog from './checkLog';
 
export namespace CompleteLogVOI {
    export interface PropsI {
        sn?: string;
    }
}

@Component
class CheckLogModals extends Vue.Component<CompleteLogVOI.PropsI> {
    @Prop({
        type: String,
    })
    sn!: string;

    visible: boolean = false;

    close() {
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    render(h) {
        return (
            <Modal
                title={'操作日志'}
                width="800"
                footer-hide
                class-name="wqms-data-complete-modal"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
            <CheckLog sn={this.sn} />
            </Modal>
        );
    }
}


export default function CheckLogModal(sn: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<CompleteLogVOI.PropsI>(CheckLogModals)({
            sn
        });
        resolve();
    });
}